import { styled } from '@mui/material/styles'
import { Box, BoxProps } from '@mui/material'

interface MapTypeContainerProps extends BoxProps {
  isProjectHomeView?: boolean;
}

export const MapTypeContainer = styled(Box, {
  shouldForwardProp: (prop) => prop !== 'isProjectHomeView',
})<MapTypeContainerProps>(({ theme, isProjectHomeView }) => ({
  position: 'absolute',
  top: isProjectHomeView ? 15 : 24,
  right: isProjectHomeView ? 15 : 24,
  zIndex: 1000,
  display: 'flex',
  flexDirection: 'column',
  boxShadow: `0 4px 12px rgba(0, 0, 0, 0.15)`,
  backgroundColor: isProjectHomeView ? 'black' : theme.palette.common.white,
  borderRadius: isProjectHomeView ? '8px' : '50%',
  overflow: 'hidden',
  ...(isProjectHomeView && {
    width: 34,
    height: 34,
    alignItems: 'center',
    justifyContent: 'center',
  }),
  '&.globalsite': {
    position: 'absolute',
    top: isProjectHomeView ? 15 : 24,
    right: isProjectHomeView ? 15 : 24,
  }
}))

export const ExpandContainer = styled(Box)(({ theme }) => ({
  position: 'absolute',
  top: 24,
  left: 24,
  display: 'flex',
  flexDirection: 'column',
  boxShadow: `0 4px 12px rgba(0, 0, 0, 0.15)`,
  backgroundColor: theme.palette.common.white,
  borderRadius: '12px',
  overflow: 'hidden',
}))